import { z } from 'zod';

// ─── backend2 `user_pathways` vocabulary ───────────────────────────────────
//
// Governed enums for the `legacy_user_pathways` mirror and the Tier 2 seam
// parse. Pelago 1.0's pathway enum and `Quitting` substance values; not the
// billing tier on `care_pathways` (ADR-157). Dependency-free so `db/schema.ts`
// can render CHECK constraints from here.

/** backend2 `ClinicalPathway`, the DB enum on `user_pathways.pathway`. */
export const CLINICAL_PATHWAY = [
  'self_guided',
  'coaching',
  'counselling',
  'counselling_med',
] as const;
export const clinicalPathwaySchema = z.enum(CLINICAL_PATHWAY);
export type ClinicalPathway = z.infer<typeof clinicalPathwaySchema>;

/** backend2 `Quitting` values written to `user_pathways.substance`. */
export const USER_PATHWAY_SUBSTANCES = [
  'cigarettes',
  'eCigarettes',
  'alcohol',
  'opioids',
  'cannabis',
  'stimulants',
] as const;
export const userPathwaySubstanceSchema = z.enum(USER_PATHWAY_SUBSTANCES);
export type UserPathwaySubstance = z.infer<typeof userPathwaySubstanceSchema>;

/** 1.0 `user_pathways.source varchar(100)`. */
export const LEGACY_USER_PATHWAY_SOURCE_MAX_LENGTH = 100;
/** 1.0 `user_pathways.substance varchar(255)`. */
export const LEGACY_USER_PATHWAY_SUBSTANCE_MAX_LENGTH = 255;
